import { defineComponent as _defineComponent } from 'vue'
import { computed, unref } from 'vue';
  import FilterListRender from '@ve/components/filters/common/components/FilterListRender/FilterListRender.vue';
  import FiltersListSection from '@ve/components/searchFilters/filterList/desktop/FiltersListSection.vue';
  import { type IHotel } from '@entities/hotel';
  import useFilterHotelsModel from '../../lib/useFilterHotelsModel';
  import { renovationFilterMethods } from '../../lib/RenovationFilterMethods';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'DesktopRenovationFilter',
  props: {
    allHotels: null,
    filteredHotels: null,
    visibleCounter: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
      allHotels: IHotel[];
      filteredHotels: IHotel[];
      visibleCounter: boolean;
  }

  
  const { renovationFilter } = useFilterHotelsModel();

  const visibleFilter = computed(() => renovationFilterMethods.getIsOneHotelHasProperty(props.allHotels));


return { __sfc: true,props, renovationFilter, visibleFilter, FilterListRender, FiltersListSection, renovationFilterMethods }
}

})